import { BELGRADE_AIRPORT_ADDRESS } from "./orderFormConstants";
import { OrderFormLocale } from "./types";

export const DEFAULT_ORDER_FORM_LOCALE: OrderFormLocale = {
  headerTitle: "Book your ride",
  route: {
    from: "From",
    fromPlaceholder: "Pickup location",
    to: "To",
    toPlaceholder: "Drop-off location",
    swapAria: "Swap pickup and dropoff",
    clearAddressAria: "Clear address",
    loading: "Searching...",
    noResults: "No results found",
    addOnMap: "Add on map",
    waypointLabel: "Stop {index}",
    waypointPlaceholder: "Stop location",
    addWaypoint: "Add stop",
    removeWaypointAria: "Remove stop",
    favoriteAddressesSection: "Saved addresses",
    searchResultsSection: "Search results",
  },
  contact: {
    title: "Contact details",
    namePlaceholder: "Full name",
    phonePlaceholder: "Phone number",
    dialCodeAria: "Country dial code",
    invalidPhone: "Please enter a valid phone number",
  },
  rideType: {
    label: "Booking type",
    orderNow: "Order now",
    schedule: "Schedule",
    orderNowDescription: "Book a ride for immediate pickup.",
    scheduleDescription: "Book a ride in advance with date and time.",
  },
  schedule: {
    dateTimeLabel: "Date & time",
    passengersLabel: "Passengers",
    luggageLabel: "Luggage",
    flightNumberLabel: "Flight number",
    flightNumberPlaceholder: "e.g. JU310",
    transferModeLabel: "Service type",
    transferModeTransfer: "Transfer",
    transferModeRental: "Hourly rental",
    transferModeTransferDescription: "Single trip on a selected route",
    transferModeRentalDescription: "Rental by the hour.",
    airportAddress: BELGRADE_AIRPORT_ADDRESS,
    durationLabel: "Duration",
    durationMinNote: "min {hours}h",
    durationFullDay: "Full day",
    timezoneNote: "All times are in CET (Central European Time)",
  },
  elit: {
    vehicleLabel: "Vehicle",
    vehiclePanelTitle: "Choose vehicle",
    vehiclePanelSubtitle: "{count} premium vehicles available",
    chooseCarLabel: "Choose car",
    luggageCountLabel: "Luggage",
    passengersCountLabel: "Passengers",
    transferLabel: "Transfer",
    hourlyRateLabel: "Po satu",
    dailyRateLabel: "Dnevni angažman (8h)",
    pricePerKmLabel: "Cena po km",
    moreCarDetailsLabel: "More car details",
  },
  childSeatLabel: "Child seat",
  comment: {
    label: "Comment",
    placeholder: "Write info to help us find you…",
  },
  price: {
    label: "Estimated price",
    loading: "Calculating price…",
    unavailable: "Complete route and vehicle to see price",
    error: "Unable to calculate price",
  },
  passenger: {
    label: "Select account",
    placeholder: "Search by ID, name or phone",
    loading: "Loading users…",
    noResults: "No users found",
  },
  submitting: "Submitting...",
  minHours: "min. {hours}h",
};
